import { SVG, getDefaultHeight } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const DocumentWithSpeakerIcon: React.FC<Props> = ({
  color,
  ...svgProps
}) => {
  return (
    <SVG
      viewBox="0 0 32.161 31.511"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 31.511)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    >
      <path d="M8.447 25.737H2.902a1.9 1.9 0 0 1-1.9-1.9V2.903a1.9 1.9 0 0 1 1.9-1.9h19.023a1.9 1.9 0 0 1 1.9 1.9v6.51m-17.119-2.7H18.12m-11.414 5.7h7.944" />
      <path d="M26.86 13.545a1.71 1.71 0 0 0-1.791.162l-7.526 4.79h-3.422a1.711 1.711 0 0 0-1.71 1.711v3.422a1.711 1.711 0 0 0 1.71 1.711h3.421l7.526 4.79a1.71 1.71 0 0 0 2.737-1.369V15.079a1.711 1.711 0 0 0-.945-1.531Z" />
      <path d="M30.109 24.435a3.985 3.985 0 0 0 0-5.024" />
      <path d="M17.583 18.502v6.843" />
      <path d="M9.017 18.55H6.595" />
    </SVG>
  );
};
